import { Cookies } from "react-cookie";
import jwt_decode from "jwt-decode";

const TOKEN_NAME = "token-wce";

const tokenManager = () => {
  const cookies = new Cookies();

  const setToken = (token) => cookies.set(TOKEN_NAME, token, { path: "/" });

  const getToken = () => cookies.get(TOKEN_NAME);

  const clearToken = () => {
    cookies.remove(TOKEN_NAME, { path: "/" });
  };

  const getTokenPayload = () => {
    const token = getToken();
    try {
      const payload = jwt_decode(token);
      return payload;
    } catch (error) {
      return {};
    }
  };

  const isTokenExist = () => {
    const token = getToken();
    if (!token || token === "") {
      return false;
    } else if (!getTokenPayload()) {
      return false;
    }
    return true;
  };

  return {
    setToken,
    clearToken,
    getToken,
    getTokenPayload,
    isTokenExist,
  };
};

export default tokenManager;
